import ProfilesTab from "@features/security/components/ProfilesTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

/**
 * Security — Profiles Index Route
 *
 * Lists all profiles with their assigned permissions.
 * Access requires security.profiles.view permission.
 */
export const Route = createFileRoute("/_app/admin/profiles/")({
  loader: requirePermission(PERMISSIONS.SECURITY.PROFILES.VIEW),
  staticData: {
    title: "Profils",
    icon: ShieldCheck,
    tab_icon: ShieldCheck,
    permission: PERMISSIONS.SECURITY.PROFILES.VIEW,
    module: "security",
    section: "Administration",
    order: 20,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des profils et de leurs permissions",
  },
  component: ProfilesTab,
});
